// Blank resolver page for shared bug-report links: /bug-report/:id resolves
// the id through /sharing/bug-report/:id and hands the browser to the returned
// URL in the same tab. loginToken-authorized (pre-company session), so the
// route lives outside JWTProtectedRoute/AuthenticatedLayout and carries its
// own guard — no shell, no sidebar, just a centred status line until the
// redirect lands.

import { useEffect } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@/store/hooks';
import { useGetBugReportUrlQuery } from '@/api/endpoints/sharingApi';

const BugReportPage = () => {
  const { t } = useTranslation();
  const { id = '' } = useParams();
  const location = useLocation();
  const loginToken = useAppSelector((state) => state.auth.loginToken);

  const { data: url, isError } = useGetBugReportUrlQuery(id, { skip: !loginToken });

  // replace, not href — the resolver page shouldn't survive in history, or
  // "back" from the destination would bounce the user straight out again.
  useEffect(() => {
    if (url) window.location.replace(url);
  }, [url]);

  if (!loginToken) {
    return <Navigate to='/login' replace state={{ from: location }} />;
  }

  return (
    <div className='bug-report__status'>{isError ? t('error_generic') : t('text_loading')}</div>
  );
};

export default BugReportPage;
